


export const FETCH_WAREHOUESES_REQUEST = "FETCH_WAREHOUESES_REQUEST"
export const FETCH_WAREHOUESES_SUCCESS = "FETCH_WAREHOUESES_SUCCESS"
export const FETCH_WAREHOUESES_FAILED = "FETCH_WAREHOUESES_FAILED"


export const ADD_WAREHOUSE_REQUEST = " ADD_WAREHOUSE_REQUEST"
export const ADD_WAREHOUSE_SUCCESS = " ADD_WAREHOUSE_SUCCESS"
export const ADD_WAREHOUSE_FAILED = " ADD_WAREHOUSE_FAILED"
